import { ITooltipAngularComp } from '@ag-grid-community/angular';
import { ITooltipParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

interface CustomTooltipParams extends ITooltipParams {
  notShowTooltipForEditMode: boolean;
}

@Component({
  imports: [TooltipComponent],
  styles: [
    `
      :host {
        position: absolute;
        pointer-events: none;
        max-width: 400px;
      }
      :host ::ng-deep div {
        word-break: break-word;
      }
    `,
  ],
  template: `
    @if (!ignoreTooltip) {
      <aux-tooltip [text]="params.value || ''" />
    }
  `,
})
export class AgTooltipComponent implements ITooltipAngularComp {
  ignoreTooltip!: boolean;
  params!: CustomTooltipParams | ITooltipParams;

  agInit(params: ITooltipParams): void {
    this.params = params;
    const rowIndex = this.params.node?.rowIndex;
    const columtId = this.params.column?.getUniqueId();

    this.ignoreTooltip =
      (this.params as CustomTooltipParams)?.notShowTooltipForEditMode &&
      this.params.api
        .getEditingCells()
        .some((cellDef) => rowIndex === cellDef.rowIndex && columtId === cellDef.column.getId());
  }
}
